// src/lib/industryEditCache.js
export const INDUSTRY_CACHE_PREFIX = "loadevo.industry.edit.v1.";
export const INDUSTRY_CACHE_TTL_MS = 10 * 60 * 1000; // 10 min

export function readIndustryCache(industryId) {
  try {
    const raw = sessionStorage.getItem(`${INDUSTRY_CACHE_PREFIX}${industryId}`);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed || !parsed.data) return null;

    const ts = Number(parsed.ts || 0);
    if (ts && Date.now() - ts > INDUSTRY_CACHE_TTL_MS) return null;

    return parsed.data;
  } catch {
    return null;
  }
}

export function writeIndustryCache(industryId, data) {
  try {
    sessionStorage.setItem(
      `${INDUSTRY_CACHE_PREFIX}${industryId}`,
      JSON.stringify({ ts: Date.now(), data })
    );
  } catch {
    // ignore
  }
}
